import { Component, Input } from '@angular/core';
import { IconCardItem } from './icon-card-item.model';

@Component({
  selector: 'oes-icon-cards',
  templateUrl: './icon-cards.component.html',
  styleUrls: ['./icon-cards.component.scss'],
  providers: []
})
export class IconCardsComponent {
  @Input() content: IconCardItem[];
  @Input() maxCardsPerRow: number = 4;
  @Input() headingSize: number = 20;
  @Input() bodySize: number = 16;

  constructor() {
  }
}
